import React from "react";
import { getStyle } from "../../styles/styles";
import { Breadcrumb } from "antd";
import { confirmPickAndPack, confirmReceivedOrder, getDeliveryInformation, getOrdersForPickAndPack } from "../../networking/NetworkingBankNotes";
import AlertBox from "../shared/AlertBox";
import NewDynamicTable from "../shared/NewDynamicTable";
import { getDefaultPagingNumberOfItems } from "../../helpers/PackageJsonHelper";

var style = getStyle();

export default class OrderDeliveryScreen extends React.Component {
    state = {
        bnOrderNo: 0,
        orderReference: '',
        reload: false,
        totalPages: 0,
        //delivery information
        customerName: '',
        deliveryDate: '',
        deliveryMethod: '',
        totalOrder: '',
        contactName: '',
        deliveryAddress: '',
        //lists
        listSameDeliveryOrders: [],
        listSelectedOrders: [],
        //alert
        showAlert: false,
        showYesNoAlert: false,
        alertTitle: '',
        alertMessage: '',
        yesNoAlertMessage: ''
    }

    componentDidMount(){
        if(this.props.data > 0) {
            var selectedOrder = []
            selectedOrder.push(this.props.data)
            this.setState({bnOrderNo: this.props.data, listSelectedOrders: selectedOrder})
            let outTransit = false;
            if(this.props.outTransit !== undefined && this.props.outTransit !== null) { outTransit = this.props.outTransit; }
            getOrdersForPickAndPack(this.props.data, outTransit, 0, 100).then(
                (value) => {
                    var totalCount = value.totalCount;
                    var pages = Math.ceil(totalCount/getDefaultPagingNumberOfItems());
                    if(totalCount === 0){
                        this.setState({listSameDeliveryOrders: [], totalPages: pages});
                    }else{
                        this.setState({listSameDeliveryOrders: value.result, totalPages: pages,});
                    }
                }
            )

            getDeliveryInformation(this.props.data).then(
                (value) =>{
                    if(value){
                        this.setState({customerName: value.CustomerName, deliveryDate: value.DeliveryDate,
                            deliveryMethod: value.DeliveryMethod, totalOrder: value.TotalOrder,
                            contactName: value.DeliveryContactName, deliveryAddress: value.DeliveryAddress
                        });
                    }
                }
            )
        }
    }
    
    handleBackLink() {
        this.props.backLink();
    }

    handleUpdateOrderReference = (event) => {
        this.setState({ orderReference: event.target.value });
    }

    handleSaveClick = async (event) => {
        if (event != null) {
            event.preventDefault();
        }
        if(!this.props.outTransit) {
            this.setState({ showYesNoAlert: true, yesNoAlertMessage: 'Are you sure you want to change the status to Ready for Delivery?'});
        } else {
            this.setState({ showYesNoAlert: true, yesNoAlertMessage: 'Are you sure you want to change the status to Out transit?'});
        }
    }

    updateOrderDelivery = async () => {
        if(this.state.orderReference !== '') {
            const response = await confirmPickAndPack(this.state.listSelectedOrders, 'Ready for delivery', this.state.orderReference);
            if (response.success) {
                this.setState({showAlert: true, alertTitle: 'Success', alertMessage: 'Delivery status updated successfully.', reload: true});
            } else {
                this.setState({showAlert: true, alertTitle: 'Error', 
                                alertMessage: response !== undefined ? response.Message : 'Something went wrong. Please try again later.'});
            }
        } else {
            this.setState({showAlert: true, alertTitle: 'Warning', alertMessage: 'Reference number cannot be empty. Please try again.'});
        }
    }

    updateOrderDeliveryTime = async () => {
        const response = await confirmReceivedOrder(this.props.data);
        if (response.success) {
            this.setState({showAlert: true, alertTitle: 'Success', alertMessage: 'Delivery status updated successfully.', reload: true});
        } else {
            this.setState({showAlert: true, alertTitle: 'Error', 
                            alertMessage: response !== undefined ? response.Message : 'Something went wrong. Please try again later.'});
        }
    }

    closeAlert = () => {
        this.setState({ showAlert: false, alertTitle: '', alertMessage: '' }, () => {
            if(this.state.reload) { this.props.backLink(); }
        });
    }
    
    noConfirmAlert = () => {
        this.setState({ showYesNoAlert: false, yesNoAlertMessage: '' });
    }

    yesConfirmAlert = () => {
        this.setState({ showYesNoAlert: false });

        if(this.props.outTransit) {
            this.updateOrderDeliveryTime();
        } else {
            this.updateOrderDelivery();
        }
    }

    handleSelectClick = (rowKeys) => {
        rowKeys.push(this.props.data)
        this.setState({ listSelectedOrders: rowKeys })
    }

    render() {        
        var bnOrderTitle = (
            <h3 className="uk-heading-divider" style={style.titleStyle} >
                <button className="uk-button uk-button-text uk-margin-small-right min-width-0" onClick={this.handleBackLink.bind(this)}>
                    <i className="fa fa-arrow-left back-arrow-white"></i>
                </button>
                Orders Ready for Delivery
            </h3>);
        if (this.props.mainTitle != null) {
            bnOrderTitle = '';
        }

        var headerTitle = 'Orders Ready for Delivery';
        if (this.props.outTransit) { headerTitle = 'Orders Out Transit'; }

        return(
            <div>
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item className="breadcrumb-item" onClick={this.handleBackLink.bind(this)}>{this.props.mainTitle}</Breadcrumb.Item>
                        <Breadcrumb.Item className="breadcrumb-item-bold">{headerTitle} - BNOrderNo: {this.state.bnOrderNo}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div>
                    {bnOrderTitle}
                    <div>
                        <ul className="uk-tab">
                            <li className={'uk-active'}><a>Order Information</a></li>
                        </ul>
                    </div>
                    <div>
                        <form className="uk-grid">
                            <div className="uk-width-2-3">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '100px'}}>Customer Name:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.customerName}</label>
                                    </div>
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '100px'}}>Delivery Date:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.deliveryDate}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-2-3">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-2 ">
                                        <label className="uk-form-label uk-align-left" style={{width: '100px'}}>Delivery Method:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.deliveryMethod}</label>
                                    </div>
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '100px'}}>Total Order:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.totalOrder}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-2-3">
                                <div className="uk-grid uk-margin">
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '100px'}}>Contact Name:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.contactName}</label>
                                    </div>
                                    <div className="uk-width-1-2">
                                        <label className="uk-form-label uk-align-left" style={{width: '100px'}}>Delivery Address:</label>
                                        <label className="uk-form-label uk-align-left">{this.state.deliveryAddress}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form className="uk-grid" >
                            {!this.props.outTransit && <div className="uk-width-1-2">
                                <div className="uk-margin" style={{ ...getStyle().inputStyle, marginTop: '5px' }}>
                                    <input
                                        className="uk-input"
                                        id="delivery-reference-no"
                                        type="text"
                                        placeholder="Enter a reference number"
                                        value={this.state.orderReference}
                                        onChange={this.handleUpdateOrderReference}
                                        autoFocus={true}/>
                                </div>
                            </div>}
                            <div className="uk-width-1-2">
                                <div className="uk-margin" style={getStyle().inputStyle}>
                                    <button className="uk-button uk-button-green" onClick={this.handleSaveClick}>Order Shipped</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div>
                        <h3 className="uk-heading-divider" style={style.titleStyle}>Orders with same Delivery Address</h3>
                        <form className="uk-grid">
                            {this.state.listSameDeliveryOrders.length > 0 &&<NewDynamicTable id="order-delivery-screen-table" 
                                data={this.state.listSameDeliveryOrders}
                                hiddenHeaders={['Key']}
                                enableClick={false}
                                useSelection={!this.props.outTransit}
                                selectionID={"Order ID"}
                                onChangeSelection={this.handleSelectClick} 
                                selectedRows={this.state.listSelectedOrders}
                            />}
                            <h5 style={style.alignCenter} hidden={this.state.listSameDeliveryOrders.length > 0}>No records found.</h5>
                        </form>
                    </div>
                </div>
                    <AlertBox id="order-delivery-alert"
                        type="Ok"
                        open={this.state.showAlert}
                        title={this.state.alertTitle}
                        message={this.state.alertMessage}
                        okClick={this.closeAlert}
                        onClose={this.closeAlert}/>

                    <AlertBox id="confirm-update-order-alert"
                        type     = "Yes/No"
                        open     = {this.state.showYesNoAlert}
                        title    = "Please confirm"
                        message  = {this.state.yesNoAlertMessage}
                        yesClick = {this.yesConfirmAlert}
                        noClick  = {this.noConfirmAlert}
                    />
            </div>
        )
    }
}